import React, { useState, useEffect } from 'react';
import { ico_pen_alt, ico_times, ico_trash } from '../../../../icon';
import Stylesheet from './File.module.css';
import {storage} from '@enigma/core/services';
import { AppContext } from '../../../../contexts/app';
import Button from '../../../../elements/Button/Button';

const File = (props) => {
    const [uploading, setUploading] = useState(false);
    const table = props.table;
    const record = props.record;
    const column = props.column;
    const file = record[column.name];
    let app = null;
    const init = appContext => {app = appContext}
    const sanitizeFileName = (name) => {
        if (name.length <= 50) return name;
        return `${name.substring(0, 50)}....`;
    }
    useEffect(() => {
        if (file) {
            // check if storage object exists
            storage.exists(file.path).then(exists => {
                if (!exists) {
                    // storage object specified by record
                    // has been deleted, either by a previous
                    // delete operation or rollbacks
                    // update record
                    props.onChange(record, true);
                }
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const onChange = async object => {
        if (!object) return;
        // delete previous file
        if (file) await storage.delete(file.path);
        await storage.uploadFile(object, 
        `${table.document}/${record.id}/`, {
            tablePath: table.document,
            table: table.id,
            record: record.id
        }, (state) => setUploading(state.progress))
        .then(async path => {
            record[column.name] = {
                path: path,
                url: await storage.getDownloadURL(path),
                name: object.name
            }
            // push changes
            props.onChange({
                path: path,
                url: await storage.getDownloadURL(path),
                name: object.name
            });
        }).catch(_ => app.toggleToast(ico_times, 
        'file could not be uploaded', true))
    }
    const OnDelete = async _ => {
        if (file) {
            // get confirmation
            const response = await app.toggleMessageBox("confirm file deletion", 
            "Are you sure you want to remove this file?, this operation can not be undone.", "yes_no");
            if (response === "yes") {
                // delete file from storage
                await storage.delete(file.path);
                // update record
                props.onChange(record, true);
            }
        }
    }

    return (
        <AppContext.Consumer>
            {app => (
                <div className={Stylesheet.Container}>
                    {init(app)}
                    {uploading 
                    ? <div className={Stylesheet.Progress}
                    style={{width: `${uploading}%`}}></div>
                    : null}
                    <div className={Stylesheet.Value}>
                        {props.defaultValue === "NAN"
                        ? <h5>{props.defaultValue}</h5>
                        : <a href={file.url} 
                        alt={file.name} target='_blank' 
                        rel="noreferrer">{
                        sanitizeFileName(file.name)}</a>}
                    </div>
                    <div className={Stylesheet.Input}>
                        <div className={Stylesheet.Button}>
                            <h5>{ico_pen_alt}</h5>
                            <input type="file" accept='image/*,.pdf,.doc,.docx'
                            onChange={event => onChange(event.target.files[0])} />
                        </div>
                        {file 
                        ? <Button icon error onClick={OnDelete}>{ico_trash}</Button> : null}
                    </div>
                </div>
            )}
        </AppContext.Consumer>
    )
}

export default File;